import type { Locale } from '@wikigold/i18n';
import { localePath } from '../i18n/locale-routing';

export function gameRouteHref(locale: Locale, pathname: string, current: Pick<Location, 'search' | 'hash'>, selectedRunId: string | null): string {
  const query = new URLSearchParams(current.search);
  for (const key of [...query.keys()]) {
    if (/(^|_)(token|uid|email|password|secret|recovery)(_|$)/i.test(key)) query.delete(key);
  }
  if (selectedRunId) query.set('run', selectedRunId);
  else query.delete('run');
  const search = query.toString();
  // Recovery fragments belong to their original page, never ordinary game navigation.
  return `${localePath(locale, pathname)}${search ? `?${search}` : ''}`;
}
